// $(
//   ".header_search_input__text, .header_search_input .search_icon, .mobile_header_search_input"
// ).click(function () {
//   setTimeout(function () {
//     $(".header_search_input__text")
//       .parents(".header__search")
//       .find(".search__input")
//       .focus();
//   }, 100);
// });



// $(document).ready(function() {
//   var $searchInput = $('input[type="search"]');
//   $searchInput.after('<label class="error-message" style="display:none;">Special characters not allowed.</label>');
//   var $errorMessage = $('.error-message');
//   $searchInput.on('input', function() {
//     var regex = /[^a-zA-Z\s0-9]/g;
//     if (regex.test($(this).val())) {
//       $errorMessage.show();
//     } else {
//       $errorMessage.hide();
//     }
//     $(this).val($(this).val().replace(regex, ''));
//   });
//   $(".search-modal__close-button").on('click',function () {
//     $errorMessage.hide();
//     $('.search__input').val('')
//   })
// });



// class PredictiveSearch extends HTMLElement {
//   constructor() {
    
//     super();
//     this.cachedResults = {};
   
//     this.input = this.querySelector('input[type="search"]');
//     this.predictiveSearchResults = this.querySelector(
//       "[data-predictive-search]"
//     );
//     this.isOpen = false;

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     const form = this.querySelector("form.search");
//     form.addEventListener("submit", this.onFormSubmit.bind(this));

//     this.input.addEventListener(
//       "input",
//       debounce((event) => {
//         this.onChange(event);
//       }, 300).bind(this)
      
//     );
//     this.input.addEventListener("focus", this.onFocus.bind(this));
//     this.addEventListener("focusout", this.onFocusOut.bind(this));
//     this.addEventListener("keyup", this.onKeyup.bind(this));
//     this.addEventListener("keydown", this.onKeydown.bind(this));
    
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
    
    
//     const searchTerm = this.getQuery();

//     if (!searchTerm.length) {
//       this.close(true);
//       return;
//     }
  
//     this.getSearchResults(searchTerm);
//   }

//   onFormSubmit(event) {
//     if (
//       !this.getQuery().length ||
//       this.querySelector('[aria-selected="true"] a')
//     )
//       event.preventDefault();
//   }

//   onFocus() {
//     // hide search input label
//     const label = document.querySelector('form.search-modal__form .field__label');
//     if (label) {
//       label.classList.add('hidden');
//     }
    
//     const searchTerm = this.getQuery();

//     if (!searchTerm.length) return;

//     if (this.getAttribute("results") === "true") {
//       this.open();
//     } else {
//       this.getSearchResults(searchTerm);
//     }
//   }

//   onFocusOut() {
//     // unhide search input label
//     const label = document.querySelector('form.search-modal__form .field__label');
//     if (label) {
//       label.classList.remove('hidden');
//     }
    
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);
//     event.preventDefault();

//     switch (event.code) {
//       case "ArrowUp":
//         this.switchOption("up");
//         break;
//       case "ArrowDown":
//         this.switchOption("down");
//         break;
//       case "Enter":
//         this.selectOption();
//         break;
//     }
//   }

//   onKeydown(event) {
//     // Prevent the cursor from moving in the input when using the up and down arrow keys
//     if (event.code === "ArrowUp" || event.code === "ArrowDown") {
//       event.preventDefault();
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute("open")) return;

//     const moveUp = direction === "up";
//     const selectedElement = this.querySelector('[aria-selected="true"]');
//     const allElements = this.querySelectorAll("li");
//     let activeElement = this.querySelector("li");

//     if (moveUp && !selectedElement) return;

//     this.statusElement.textContent = "";

//     if (!moveUp && selectedElement) {
//       activeElement = selectedElement.nextElementSibling || allElements[0];
//     } else if (moveUp) {
//       activeElement =
//         selectedElement.previousElementSibling ||
//         allElements[allElements.length - 1];
//     }

//     if (activeElement === selectedElement) return;

//     activeElement.setAttribute("aria-selected", true);
//     if (selectedElement) selectedElement.setAttribute("aria-selected", false);

//     this.setLiveRegionText(activeElement.textContent);
//     this.input.setAttribute("aria-activedescendant", activeElement.id);
//   }

//   selectOption() {
//     const selectedProduct = this.querySelector(
//       '[aria-selected="true"] a, [aria-selected="true"] button'
//     );

//     if (selectedProduct) selectedProduct.click();
//   }

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(" ", "-").toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       return;
//     }

//     fetch(
//       `${routes.predictive_search_url}?q=${encodeURIComponent(
//         searchTerm
//       )}&${encodeURIComponent("resources[type]")}=product&${encodeURIComponent(
//         "resources[limit]"
//       )}=4&section_id=predictive-search`
//     )
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, "text/html")
//           .querySelector("#shopify-section-predictive-search").innerHTML;
//         this.cachedResults[queryKey] = resultsMarkup;
//         this.renderSearchResults(resultsMarkup);
//       })
//       .catch((error) => {
//         this.close();
//         throw error;
//       });
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement =
//       this.statusElement || this.querySelector(".predictive-search-status");
//     this.loadingText =
//       this.loadingText || this.getAttribute("data-loading-text");

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute("loading", true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute("aria-hidden", "false");
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute("aria-hidden", "true");
//     }, 1000);
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute("results", true);

//     this.setLiveRegionResults();
//     this.open();

//     var lin_s = $("#predictive-search-results-list li").length;
//     if (lin_s == 1) {
//       $(".predictive-search__item.predictive-search__item--term").html(
//         '<div class="noresult-search-popup"><figure><svg xmlns="http://www.w3.org/2000/svg" width="172.876" height="150.489" viewBox="0 0 172.876 150.489"><g id="Group_206970" data-name="Group 206970" transform="translate(-789.254 -349.521)"><path id="Path_2943" data-name="Path 2943" d="M243.39,665.807A67.189,67.189,0,1,0,176.2,598.618,67.244,67.244,0,0,0,243.39,665.807Z" transform="translate(635.234 -169.826)" fill="#eaeef9"/><path id="Path_2944" data-name="Path 2944" d="M195.3,565.417h81.219a5.877,5.877,0,0,1,5.779,5.78v51.256a5.877,5.877,0,0,1-5.779,5.779H195.3a5.877,5.877,0,0,1-5.779-5.779V571.2A5.877,5.877,0,0,1,195.3,565.417Z" transform="translate(641.047 -154.991)" fill="#fff"/><path id="Path_2945" data-name="Path 2945" d="M279.995,569.206a5.108,5.108,0,1,0-7.218-.279A5.2,5.2,0,0,0,279.995,569.206Z" transform="translate(676.786 -157.21)" fill="#eaeef9"/><path id="Path_2946" data-name="Path 2946" d="M278.675,551.7a2.162,2.162,0,1,0-3.054-.139A2.065,2.065,0,0,0,278.675,551.7Z" transform="translate(678.383 -162.614)" fill="#eaeef9"/><path id="Path_2947" data-name="Path 2947" d="M240.338,529.41a1.476,1.476,0,1,0-2.083-.139A1.518,1.518,0,0,0,240.338,529.41Z" transform="translate(662.164 -171.831)" fill="#eaeef9"/><path id="Path_2948" data-name="Path 2948" d="M292.739,556.85,272.511,592.9a2.387,2.387,0,0,1-3.347.912L234.488,573.58a2.386,2.386,0,0,1-.914-3.346L260.19,524.3a2.389,2.389,0,0,1,3.347-.914l25.1,14.6Z" transform="translate(660.113 -173.497)" fill="#f2f6fa"/><path id="Path_2949" data-name="Path 2949" d="M273.657,533.441l-5.779,9.733a2.939,2.939,0,0,0,1.064,3.955l8.669,5.019" transform="translate(675.088 -168.948)" fill="#d5dae6"/><path id="Path_2950" data-name="Path 2950" d="M257.651,540.052a6.816,6.816,0,0,1,1.673-.152h1.824c.609.152,1.369.3,1.978.455.76.3,1.369.609,1.977.914a6.722,6.722,0,0,1,2.281,1.824,5.714,5.714,0,0,1,1.369,2.281,6.694,6.694,0,0,1,.3,2.433,7.5,7.5,0,0,1-.912,2.586,9.808,9.808,0,0,1-1.521,1.978,7.18,7.18,0,0,1-1.826,1.064,4.043,4.043,0,0,1-1.824.457l-1.673.152a6.678,6.678,0,0,0-1.521.3,2.457,2.457,0,0,0-1.064.609l-1.673,2.129-2.736-1.521,1.217-2.736a3.62,3.62,0,0,1,.912-1.217A5.4,5.4,0,0,1,257.8,551c.608-.152,1.064-.152,1.673-.3a7.625,7.625,0,0,0,1.824-.3,7.338,7.338,0,0,0,1.673-.608,2.688,2.688,0,0,0,1.217-1.369,10.222,10.222,0,0,0,.455-1.217,2.271,2.271,0,0,0-.151-1.064,2.441,2.441,0,0,0-.609-1.064,6.607,6.607,0,0,0-1.064-.914,5.653,5.653,0,0,0-1.673-.76,4.2,4.2,0,0,0-1.369-.152h-1.064a.91.91,0,0,1-.608-.152,1.249,1.249,0,0,1-.609-.912Zm-7.757,20.076a4.031,4.031,0,0,1,.76-.912c.3-.152.609-.457.914-.457a2.584,2.584,0,0,1,2.129.3,3.99,3.99,0,0,1,.912.76l.457.912a2.665,2.665,0,0,1-1.977,3.347,3.344,3.344,0,0,1-2.13-.3,4.062,4.062,0,0,1-.912-.76c-.152-.3-.457-.609-.457-.914a1.3,1.3,0,0,1,0-1.064A2.159,2.159,0,0,1,249.894,560.128Z" transform="translate(667.215 -166.129)" fill="#ced6e2"/><path id="Path_2951" data-name="Path 2951" d="M194.317,535.943l23.118,24.183a1.977,1.977,0,0,1-.152,2.889l-23.575,22.359a1.979,1.979,0,0,1-2.89-.152l-29.506-31.18a1.977,1.977,0,0,1,.152-2.889l17.187-16.123Z" transform="translate(628.494 -168.255)" fill="#f2f6fa"/><path id="Path_2952" data-name="Path 2952" d="M173.109,534.817l6.388,6.693a2.389,2.389,0,0,0,3.347,0l5.931-5.627" transform="translate(633.884 -168.347)" fill="#d5dae6"/><path id="Path_2953" data-name="Path 2953" d="M174.38,551.541a4.484,4.484,0,0,1,.3-1.369l.457-1.369a6.247,6.247,0,0,1,.76-1.369,9.911,9.911,0,0,1,1.217-1.367,5.778,5.778,0,0,1,1.978-1.369,4.676,4.676,0,0,1,1.977-.457,8.9,8.9,0,0,1,1.978.3,12.549,12.549,0,0,1,1.824,1.217,3.933,3.933,0,0,1,1.066,1.672c.151.457.3,1.066.455,1.674v1.521c-.152.457-.152.912-.3,1.369,0,.457-.151.76-.151,1.217a1.119,1.119,0,0,0,.3.912l1.217,1.826-1.824,1.674-1.826-1.674a2.748,2.748,0,0,1-.76-1.064,3.349,3.349,0,0,1-.152-1.217c0-.457.152-.914.152-1.369a6.231,6.231,0,0,0,0-2.738,6.163,6.163,0,0,0-.761-1.369,1.511,1.511,0,0,0-.76-.609,1.925,1.925,0,0,0-.912-.152,2.164,2.164,0,0,0-.914.3,3.2,3.2,0,0,0-.912.609c-.3.3-.608.76-.912,1.064a7.4,7.4,0,0,0-.457,1.064,1.654,1.654,0,0,0-.152.76c0,.152-.151.3-.3.457-.152.3-.609.3-.914.152Zm13.993,10.647a3.345,3.345,0,0,1-.457-.76,1.931,1.931,0,0,1-.152-.914,2.439,2.439,0,0,1,.761-1.672,3.281,3.281,0,0,1,.76-.457,1.928,1.928,0,0,1,.912-.152,2.289,2.289,0,0,1,2.13,1.521,1.942,1.942,0,0,1,.151.912c0,.3-.151.609-.151.912a2.672,2.672,0,0,1-.609.761,1.294,1.294,0,0,1-.76.455,3.11,3.11,0,0,1-1.673,0A1.389,1.389,0,0,1,188.373,562.188Z" transform="translate(634.439 -164.234)" fill="#ced6e2"/><path id="Path_2954" data-name="Path 2954" d="M239.6,568.554l-8.974,32.092a2,2,0,0,1-2.586,1.369l-31.18-9.126a2,2,0,0,1-1.369-2.586l12.167-41.37a2,2,0,0,1,2.586-1.369l22.663,6.692Z" transform="translate(643.594 -162.842)" fill="#f2f6fa"/><path id="Path_2955" data-name="Path 2955" d="M222.4,552.221l-2.893,9.07a2.429,2.429,0,0,0,1.673,2.89l8.021,2.267" transform="translate(654.105 -160.751)" fill="#d5dae6"/><path id="Path_2956" data-name="Path 2956" d="M210.271,560.989q.685-.226,1.369-.455a4.5,4.5,0,0,1,1.521-.3h1.673a7.625,7.625,0,0,1,1.824.3,5.618,5.618,0,0,1,2.13,1.064,7.2,7.2,0,0,1,1.52,1.521,9.29,9.29,0,0,1,.761,1.824,4.882,4.882,0,0,1-.152,2.13,5.153,5.153,0,0,1-.912,1.824,4.624,4.624,0,0,1-1.217,1.217,6.2,6.2,0,0,1-1.369.761l-1.369.455c-.3.152-.761.3-1.064.457a1.012,1.012,0,0,0-.609.76l-.912,1.978-2.433-1.064.455-2.433a1.541,1.541,0,0,1,.609-1.066,2.737,2.737,0,0,1,1.064-.76,10.47,10.47,0,0,0,1.217-.457,5.393,5.393,0,0,0,1.369-.608,5.332,5.332,0,0,0,1.217-.761,2.918,2.918,0,0,0,.76-1.369v-.76a2.155,2.155,0,0,0-.3-.912c-.152-.3-.457-.457-.761-.761a7.567,7.567,0,0,0-1.064-.455,4.683,4.683,0,0,0-1.521-.152,2.583,2.583,0,0,0-1.064.152,6.562,6.562,0,0,0-.76.152c-.152,0-.3.152-.609,0a.654.654,0,0,1-.608-.609Zm-2.281,17.492c.152-.3.152-.609.457-.761.152-.3.455-.455.608-.608a2.2,2.2,0,0,1,1.673-.152,3.32,3.32,0,0,1,.76.457c.152.151.457.455.609.608a2.055,2.055,0,0,1-.912,2.89,2.2,2.2,0,0,1-1.673.152c-.3-.152-.609-.152-.761-.457-.3-.152-.455-.457-.608-.608-.152-.3-.152-.457-.3-.761A1.137,1.137,0,0,0,207.99,578.481Z" transform="translate(649.042 -157.256)" fill="#ced6e2"/><path id="Path_2957" data-name="Path 2957" d="M291.532,611.558l-29.506,15.969a2.046,2.046,0,0,1-2.738-.912L244.535,597.87a2.046,2.046,0,0,1,.912-2.738l38.328-20.23a2.047,2.047,0,0,1,2.738.914l10.647,20.836Z" transform="translate(664.97 -150.941)" fill="#f2f6fa"/><path id="Path_2958" data-name="Path 2958" d="M283.875,590.193l-8.214,4.259a2.68,2.68,0,0,0-1.064,3.195l3.65,7.3" transform="translate(678.103 -144.178)" fill="#d5dae6"/><path id="Path_2959" data-name="Path 2959" d="M271.456,587.44c.457.152.76.457,1.217.609a3.2,3.2,0,0,1,1.217.912,7.666,7.666,0,0,1,1.064,1.217,5.447,5.447,0,0,1,1.064,1.521,3.8,3.8,0,0,1,.609,2.129,9.966,9.966,0,0,1,0,2.13,9.291,9.291,0,0,1-.761,1.824,4.732,4.732,0,0,1-1.672,1.369,6.439,6.439,0,0,1-1.826.609,3.123,3.123,0,0,1-1.673,0,5.783,5.783,0,0,1-1.52-.457l-1.217-.608c-.3-.152-.761-.3-1.066-.457s-.76-.152-.912.152l-1.977.76-1.064-2.281,1.977-1.369a1.637,1.637,0,0,1,1.217-.3,3.348,3.348,0,0,1,1.217.152,6.6,6.6,0,0,1,1.064.609,12.175,12.175,0,0,0,1.369.608c.457.152.761.152,1.369.3a3.4,3.4,0,0,0,1.521-.457,1.919,1.919,0,0,0,1.064-1.52c.152-.3,0-.609,0-1.066a5.561,5.561,0,0,0-.457-1.064,5.308,5.308,0,0,0-.76-1.217,3.343,3.343,0,0,0-.76-.608c-.152-.152-.457-.3-.609-.457s-.3-.152-.457-.457a.7.7,0,0,1,0-.76Zm-14.145,10.495a.933.933,0,0,1,.912-.152c.3-.152.609,0,.761,0a1.741,1.741,0,0,1,1.217,1.066,1.923,1.923,0,0,1,.152.912v.76a2.11,2.11,0,0,1-1.066,1.217,1.923,1.923,0,0,1-.912.152h-.76a1.737,1.737,0,0,1-1.217-1.064,1.928,1.928,0,0,1-.152-.912c-.152-.3,0-.609,0-.761.152-.3.3-.455.3-.76C256.7,598.239,257.159,598.239,257.311,597.935Z" transform="translate(670.141 -145.379)" fill="#ced6e2"/><path id="Path_2960" data-name="Path 2960" d="M284.143,589.04v25.247a6.04,6.04,0,0,1-5.931,5.933h-83.5a6.039,6.039,0,0,1-5.931-5.933V586.911" transform="translate(640.724 -145.61)" fill="none" stroke="#1676ee" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path id="Path_2961" data-name="Path 2961" d="M280.255,577.064H251.662a11.678,11.678,0,0,0-7.6,2.738l-7.6,6.083a12.568,12.568,0,0,1-7.6,2.738H196.3a5.939,5.939,0,0,0-5.931,5.931,1.931,1.931,0,0,0,.152.914l5.931,31.178a6.173,6.173,0,0,0,5.931,5.171H271.89a5.916,5.916,0,0,0,5.931-5.019l8.366-42.89a5.858,5.858,0,0,0-5.019-6.692A1.932,1.932,0,0,0,280.255,577.064Z" transform="translate(641.417 -149.908)" fill="#fff"/><path id="Path_2962" data-name="Path 2962" d="M291.076,573.146H257.007a14.68,14.68,0,0,0-8.974,3.195l-9.126,7.452a14.09,14.09,0,0,1-8.974,3.195H190.846a7.139,7.139,0,0,0-7.149,7.148,2.585,2.585,0,0,0,.152,1.064L191,633.072a7.339,7.339,0,0,0,7.148,6.236h82.891a7.326,7.326,0,0,0,7.149-6.083l9.886-51.865a7.19,7.19,0,0,0-5.931-8.214Z" transform="translate(638.505 -151.618)" fill="#fff"/><path id="Path_2963" data-name="Path 2963" d="M213.819,603.105a3.65,3.65,0,1,0-3.651-3.65A3.7,3.7,0,0,0,213.819,603.105Z" transform="translate(650.059 -141.728)" fill="#989fb0"/><path id="Path_2964" data-name="Path 2964" d="M233.617,602.682a3.65,3.65,0,1,0-3.65-3.65A3.7,3.7,0,0,0,233.617,602.682Z" transform="translate(658.701 -141.913)" fill="#989fb0"/><path id="Path_2965" data-name="Path 2965" d="M232.761,606.391h-1.977a6.509,6.509,0,0,0-8.974-2.89,5.921,5.921,0,0,0-2.89,2.89h-1.977a8.557,8.557,0,0,1,10.95-5.019A8.775,8.775,0,0,1,232.761,606.391Z" transform="translate(653.017 -139.538)" fill="#989fb0"/><path id="Path_2966" data-name="Path 2966" d="M281.393,641.83c-1.672,0-1.064.152-13.993-12.776a18.739,18.739,0,1,1,3.955-4.259l12.016,12.016A2.867,2.867,0,0,1,281.393,641.83Zm-25.1-40.3a12.776,12.776,0,1,0,0,25.552,11.5,11.5,0,0,0,2.281-.152,8.719,8.719,0,0,0,2.13-.609c.76-.3,1.367-.608,1.977-.912a9.748,9.748,0,0,0,1.977-1.521c.457-.455,1.066-1.064,1.521-1.521a12.553,12.553,0,0,0,1.217-1.824c.3-.609.609-1.369.914-2.13a6.115,6.115,0,0,0,.455-2.281c0-.608.152-1.064.152-1.672A12.569,12.569,0,0,0,256.3,601.526Z" transform="translate(662.028 -141.821)" fill="#989fb0"/><path id="Path_2967" data-name="Path 2967" d="M206.462,595.345l8.212-4.41" transform="translate(648.442 -143.854)" fill="none" stroke="#989fb0" stroke-width="1.5"/><path id="Path_2968" data-name="Path 2968" d="M239.981,593.91l-8.214-4.564" transform="translate(659.486 -144.547)" fill="none" stroke="#989fb0" stroke-width="1.5"/></g></svg></figure><span>Sorry we could’t find any matches for ' +
//           $("#Search-In-Modal").val() +
//           '</span><div class="term-search-popup">Please try and search another term</div> </div>'
//       );
//       console.log("jgj", lin_s, $("#Search-In-Modal").val());
//     }
//   }

//   setLiveRegionResults() {
//     this.removeAttribute("loading");
//     this.setLiveRegionText(
//       this.querySelector("[data-predictive-search-live-region-count-value]")
//         .textContent
//     );
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight =
//       window.innerHeight -
//       document.getElementById("shopify-section-header").getBoundingClientRect()
//         .bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     this.predictiveSearchResults.style.maxHeight =
//       this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
//     this.setAttribute("open", true);
//     this.input.setAttribute("aria-expanded", true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = "";
//       this.removeAttribute("results");
//     }

//     const selected = this.querySelector('[aria-selected="true"]');

//     if (selected) selected.setAttribute("aria-selected", false);

//     this.input.setAttribute("aria-activedescendant", "");
//     this.removeAttribute("open");
//     this.input.setAttribute("aria-expanded", false);
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute("style");

//     this.isOpen = false;
//   }
// }

// customElements.define("predictive-search", PredictiveSearch);





// class SearchForm extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     if (this.searchFormInitialized) return;
//     this.searchFormInitialized = true;

//     this.input = this.querySelector('input[type="search"]');
//     this.resetButton = this.querySelector('button[type="reset"]');

//     if (this.input) {
//       this.input.form.addEventListener('reset', this.onFormReset.bind(this));
//       this.input.addEventListener(
//         'input',
//         debounce((event) => {
//           this.onChange(event);
//         }, 300).bind(this)
//       );
//     }
//   }

//   setupEventListeners() {
//     this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.addEventListener('keyup', this.onKeyup.bind(this));
//     this.addEventListener('keydown', this.onKeydown.bind(this));
//   }

//   toggleResetButton() {
//     console.log(this.resetButton);
//     const resetIsHidden = this.resetButton.classList.contains('hidden');
//     if (this.input.value.length > 0 && resetIsHidden) {
//       this.resetButton.classList.remove('hidden');
//     } else if (this.input.value.length === 0 && !resetIsHidden) {
//       this.resetButton.classList.add('hidden');
//     }
//   }

//   onChange() {
//     this.toggleResetButton();
//   }

//   shouldResetForm() {
//     return !document.querySelector('[aria-selected="true"] a');
//   }

//   onFormReset(event) {
//     // Prevent default so the form reset doesn't set the value gotten from the url on page load
//     event.preventDefault();
//     // Don't reset if the user has selected an element on the predictive search dropdown
//     if (this.shouldResetForm()) {
//       this.input.value = '';
//       this.input.focus();
//       this.toggleResetButton();
//     }
//   }
// }

// customElements.define('search-form', SearchForm);



// class PredictiveSearch extends SearchForm {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = '';

//   }

//   connectedCallback() {
//     super.connectedCallback();
//     if (this.predictiveSearchInitialized) return;
//     this.predictiveSearchInitialized = true;

//     this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
//     this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.addEventListener('keyup', this.onKeyup.bind(this));
//     this.addEventListener('keydown', this.onKeydown.bind(this));
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     super.onChange();
//     const newSearchTerm = this.getQuery();
//     if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
//       // Remove the results when they are no longer relevant for the new search term
//       // so they don't show up when the dropdown opens again
//       this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
//     }

//     // Update the term asap, don't wait for the predictive search query to finish loading
//     this.updateSearchForTerm(this.searchTerm, newSearchTerm);

//     this.searchTerm = newSearchTerm;

//     if (!this.searchTerm.length) {
//       this.close(true);
//       return;
//     }

//     this.getSearchResults(this.searchTerm);
//   }

//   onFormSubmit(event) {
//     if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.searchTerm = '';
//       this.abortController.abort();
//       this.abortController = new AbortController();
//       this.closeResults(true);
//     }
//   }

//   onFocus() {
//     const currentSearchTerm = this.getQuery();

//     if (!currentSearchTerm.length) return;

//     if (this.searchTerm !== currentSearchTerm) {
//       // Search term was changed from other search input, treat it as a user change
//       this.onChange();
//     } else if (this.getAttribute('results') === 'true') {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);
//     event.preventDefault();

//     switch (event.code) {
//       case 'ArrowUp':
//         this.switchOption('up');
//         break;
//       case 'ArrowDown':
//         this.switchOption('down');
//         break;
//       case 'Enter':
//         this.selectOption();
//         break;
//     }
//   }

//   onKeydown(event) {
//     // Prevent the cursor from moving in the input when using the up and down arrow keys
//     if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
//       event.preventDefault();
//     }
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
//     const currentButtonText = searchForTextElement?.innerText;
//     if (currentButtonText) {
//       if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
//         // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
//         return;
//       }
//       const newButtonText = currentButtonText.replace(previousTerm, newTerm);
//       searchForTextElement.innerText = newButtonText;
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute('open')) return;

//     const moveUp = direction === 'up';
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     // Filter out hidden elements (duplicated page and article resources) thanks
//     // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
//     const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
//       (element) => element.offsetParent !== null
//     );
//     let activeElementIndex = 0;

//     if (moveUp && !selectedElement) return;

//     let selectedElementIndex = -1;
//     let i = 0;

//     while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedElementIndex = i;
//       }
//       i++;
//     }

//     this.statusElement.textContent = '';

//     if (!moveUp && selectedElement) {
//       activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
//     } else if (moveUp) {
//       activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
//     }

//     if (activeElementIndex === selectedElementIndex) return;

//     const activeElement = allVisibleElements[activeElementIndex];

//     activeElement.setAttribute('aria-selected', true);
//     if (selectedElement) selectedElement.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', activeElement.id);
//   }

//   selectOption() {
//     const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

//     if (selectedOption) selectedOption.click();
//   }

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(' ', '-').toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);
//       searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
//       return;
//     }

//     const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);

//     fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
//       signal: this.abortController.signal,
//     })
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, 'text/html')
//           .querySelector('#shopify-section-predictive-search').innerHTML;
//         // Save bandwidth keeping the cache in all instances synced
//         this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
//           predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
//         });
//         this.renderSearchResults(resultsMarkup);

//         searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
//       })
//       .catch((error) => {
//         if (error?.code === 20) {
//           // Code 20 means the call was aborted
//           searchDeferred?.reject(error);
//           return;
//         }
//         searchDeferred?.reject(error);
//         this.close();
//         throw error;
//       });
//   }

//   getTotalResultCount() {
//     return parseInt(this.predictiveSearchResults.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
//   }

//   dispatchSearchUpdateEvent(query) {
//     const { SearchUpdateEvent } = window.StandardEvents || {};
//     if (!SearchUpdateEvent) return null;

//     const deferred = SearchUpdateEvent.createPromise();
//     this.dispatchEvent(
//       new SearchUpdateEvent({
//         search: { query },
//         promise: deferred.promise,
//       })
//     );
//     return deferred;
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
//     this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute('loading', true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute('aria-hidden', 'false');
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute('aria-hidden', 'true');
//     }, 1000);
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute('results', true);

//     this.setLiveRegionResults();
//     this.initLazyImages();
//     this.open();
//   }

//   setLiveRegionResults() {
//     this.removeAttribute('loading');
//     this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
//   }

//   initLazyImages() {
//     const lazyImages = this.predictiveSearchResults.querySelectorAll('[defer-img-lazy]');
//     lazyImages.forEach((img) => {
//       if (img.dataset.src) {
//         img.src = img.dataset.src;
//         img.removeAttribute('defer-img-lazy'); // optional, avoids re-processing
//       }
//     });
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight =
//       window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
//     this.setAttribute('open', true);
//     this.input.setAttribute('aria-expanded', true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     this.closeResults(clearSearchTerm);
//     this.isOpen = false;
//   }

//   closeResults(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = '';
//       this.removeAttribute('results');
//     }
//     const selected = this.querySelector('[aria-selected="true"]');

//     if (selected) selected.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', '');
//     this.removeAttribute('loading');
//     this.removeAttribute('open');
//     this.input.setAttribute('aria-expanded', false);
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute('style');
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);









// // --- Recent searches storage helpers ---
// const RECENT_SEARCHES_KEY = 'orient:recent-searches';
// const RECENT_SEARCHES_LIMIT = 5;

// function getRecentSearches() {
//   try {
//     const stored = JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY));
//     return Array.isArray(stored) ? stored : [];
//   } catch (e) {
//     return [];
//   }
// }

// function saveRecentSearch(term) {
//   const trimmed = (term || '').trim();
//   if (!trimmed) return;

//   let searches = getRecentSearches().filter(
//     (item) => item.toLowerCase() !== trimmed.toLowerCase()
//   );
//   searches.unshift(trimmed);
//   searches = searches.slice(0, RECENT_SEARCHES_LIMIT);

//   try {
//     localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
//   } catch (e) {
//     // localStorage unavailable (private mode etc.) — fail silently
//     console.log('Recent searches localStorage unavailable');
//   }
// }

// class SearchForm extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     if (this.searchFormInitialized) return;
//     this.searchFormInitialized = true;

//     this.input = this.querySelector('input[type="search"]');
//     this.resetButton = this.querySelector('button[type="reset"]');
//     this.recentSearchesContainer = this.querySelector('[data-recent-searches]');
//     this.recentSearchesList = this.querySelector('[data-recent-searches-list]');
//     this.detailsElement = this.closest('details');

//     if (this.input) {
//       this.input.form.addEventListener('reset', this.onFormReset.bind(this));
//       this.input.addEventListener(
//         'input',
//         debounce((event) => {
//           this.onChange(event);
//         }, 300).bind(this)
//       );
//       // Immediate (non-debounced) — purely toggles recent vs results visibility
//       this.input.addEventListener('input', this.onInputImmediate.bind(this));
//       this.input.addEventListener('focus', this.onInputFocus.bind(this));
//     }

//     if (this.detailsElement) {
//       this.detailsElement.addEventListener('toggle', this.onDetailsToggle.bind(this));
//     }

//     if (this.recentSearchesList) {
//       this.recentSearchesList.addEventListener('click', this.onRecentSearchClick.bind(this));
//     }
//   }

//   onDetailsToggle() {
//     if (!this.detailsElement.open) {
//       this.hideRecentSearches();
//       return;
//     }
//     // rAF avoids a focus/scroll race while the modal is still animating in
//     requestAnimationFrame(() => {
//       this.input.focus();
//       this.onInputFocus();
//     });
//   }

//   onInputFocus() {
//     if (!this.getQuery().length) {
//       this.showRecentSearches();
//     } else {
//       this.hideRecentSearches();
//     }
//   }

//   onInputImmediate() {
//     if (this.getQuery().length) {
//       this.hideRecentSearches();
//     } else {
//       this.showRecentSearches();
//     }
//   }

//   onRecentSearchClick(event) {
//     const item = event.target.closest('[data-recent-search-term]');
//     if (!item) return;

//     const term = item.getAttribute('data-recent-search-term');
//     this.input.value = term;
//     this.input.focus();
//     this.hideRecentSearches();
//     this.onChange(); // fire immediately, don't wait on the debounce
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   showRecentSearches() {
//     if (!this.recentSearchesContainer) return;
//     this.renderRecentSearches();
//     if (this.predictiveSearchResults) {
//       this.predictiveSearchResults.classList.add('hidden'); // or your existing hide mechanism
//     }
//     this.removeAttribute('open');
//   }

//   hideRecentSearches() {
//     if (!this.recentSearchesContainer) return;
//     this.recentSearchesContainer.classList.add('hidden');
//     if (this.predictiveSearchResults) {
//       this.predictiveSearchResults.classList.remove('hidden');
//     }
//   }

//   renderRecentSearches() {
//     if (!this.recentSearchesContainer || !this.recentSearchesList) return;

//     const searches = getRecentSearches();

//     if (!searches.length) {
//       this.recentSearchesContainer.classList.add('hidden');
//       return;
//     }

//     this.recentSearchesList.innerHTML = searches
//       .map((term) => {
//         const safeTerm = term.replace(/"/g, '&quot;');
//         return `<button type="button" class="recent-searches__item" data-recent-search-term="${safeTerm}">${term}</button>`;
//       })
//       .join('');

//     this.recentSearchesContainer.classList.remove('hidden');
//   }

//   toggleResetButton() {
//     if (!this.resetButton) return;
//     const resetIsHidden = this.resetButton.classList.contains('hidden');
//     if (this.input.value.length > 0 && resetIsHidden) {
//       this.resetButton.classList.remove('hidden');
//     } else if (this.input.value.length === 0 && !resetIsHidden) {
//       this.resetButton.classList.add('hidden');
//     }
//   }

//   onChange() {
//     this.toggleResetButton();
//   }

//   shouldResetForm() {
//     return !document.querySelector('[aria-selected="true"] a');
//   }

//   onFormReset(event) {
//     event.preventDefault();
//     if (this.shouldResetForm()) {
//       this.input.value = '';
//       this.input.focus();
//       this.toggleResetButton();
//       this.showRecentSearches();
//     }
//   }
// }

// customElements.define('search-form', SearchForm);


// class PredictiveSearch extends SearchForm {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = '';
//   }

//   connectedCallback() {
//     super.connectedCallback();
//     if (this.predictiveSearchInitialized) return;
//     this.predictiveSearchInitialized = true;

//     this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
//     this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');

//     // Record a term as "recent" whenever a result is actually clicked
//     this.predictiveSearchResults.addEventListener('click', (event) => {
//       if (event.target.closest('a') && this.searchTerm) {
//         saveRecentSearch(this.searchTerm);
//       }
//     });

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.addEventListener('keyup', this.onKeyup.bind(this));
//     this.addEventListener('keydown', this.onKeydown.bind(this));
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     super.onChange();
//     const newSearchTerm = this.getQuery();
//     if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
//       this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
//     }

//     this.updateSearchForTerm(this.searchTerm, newSearchTerm);
//     this.searchTerm = newSearchTerm;

//     if (!this.searchTerm.length) {
//       this.close(true);
//       this.showRecentSearches();
//       return;
//     }

//     this.hideRecentSearches();
//     this.getSearchResults(this.searchTerm);
//   }

//   onFormSubmit(event) {
//     if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
//       event.preventDefault();
//     }
//     if (this.getQuery().length) {
//       saveRecentSearch(this.getQuery());
//     }
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.searchTerm = '';
//       this.abortController.abort();
//       this.abortController = new AbortController();
//       this.closeResults(true);
//     }
//   }

//   onFocus() {
//     const currentSearchTerm = this.getQuery();

//     if (!currentSearchTerm.length) {
//       this.showRecentSearches();
//       return;
//     }

//     this.hideRecentSearches();

//     if (this.searchTerm !== currentSearchTerm) {
//       this.onChange();
//     } else if (this.getAttribute('results') === 'true') {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) {
//         this.close();
//         this.hideRecentSearches();
//       }
//     });
//   }

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);
//     event.preventDefault();

//     switch (event.code) {
//       case 'ArrowUp':
//         this.switchOption('up');
//         break;
//       case 'ArrowDown':
//         this.switchOption('down');
//         break;
//       case 'Enter':
//         this.selectOption();
//         break;
//     }
//   }

//   onKeydown(event) {
//     if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
//       event.preventDefault();
//     }
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
//     const currentButtonText = searchForTextElement?.innerText;
//     if (currentButtonText) {
//       if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
//         return;
//       }
//       const newButtonText = currentButtonText.replace(previousTerm, newTerm);
//       searchForTextElement.innerText = newButtonText;
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute('open')) return;

//     const moveUp = direction === 'up';
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
//       (element) => element.offsetParent !== null
//     );
//     let activeElementIndex = 0;

//     if (moveUp && !selectedElement) return;

//     let selectedElementIndex = -1;
//     let i = 0;

//     while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedElementIndex = i;
//       }
//       i++;
//     }

//     this.statusElement.textContent = '';

//     if (!moveUp && selectedElement) {
//       activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
//     } else if (moveUp) {
//       activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
//     }

//     if (activeElementIndex === selectedElementIndex) return;

//     const activeElement = allVisibleElements[activeElementIndex];

//     activeElement.setAttribute('aria-selected', true);
//     if (selectedElement) selectedElement.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', activeElement.id);
//   }

//   selectOption() {
//     const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
//     if (selectedOption) selectedOption.click();
//   }

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(' ', '-').toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);
//       searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
//       return;
//     }

//     const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);

//     fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
//       signal: this.abortController.signal,
//     })
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }
//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, 'text/html')
//           .querySelector('#shopify-section-predictive-search').innerHTML;
//         this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
//           predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
//         });
//         this.renderSearchResults(resultsMarkup);
//         searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
//       })
//       .catch((error) => {
//         if (error?.code === 20) {
//           searchDeferred?.reject(error);
//           return;
//         }
//         searchDeferred?.reject(error);
//         this.close();
//         throw error;
//       });
//   }

//   getTotalResultCount() {
//     return parseInt(this.predictiveSearchResults.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
//   }

//   dispatchSearchUpdateEvent(query) {
//     const { SearchUpdateEvent } = window.StandardEvents || {};
//     if (!SearchUpdateEvent) return null;

//     const deferred = SearchUpdateEvent.createPromise();
//     this.dispatchEvent(
//       new SearchUpdateEvent({
//         search: { query },
//         promise: deferred.promise,
//       })
//     );
//     return deferred;
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
//     this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute('loading', true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute('aria-hidden', 'false');
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute('aria-hidden', 'true');
//     }, 1000);
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute('results', true);

//     this.setLiveRegionResults();
//     this.initLazyImages();
//     this.open();
//   }

//   setLiveRegionResults() {
//     this.removeAttribute('loading');
//     this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
//   }

//   initLazyImages() {
//     const lazyImages = this.predictiveSearchResults.querySelectorAll('[defer-img-lazy]');
//     lazyImages.forEach((img) => {
//       if (img.dataset.src) {
//         img.src = img.dataset.src;
//         img.removeAttribute('defer-img-lazy');
//       }
//     });
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight =
//       window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
//     this.setAttribute('open', true);
//     this.input.setAttribute('aria-expanded', true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     this.closeResults(clearSearchTerm);
//     this.isOpen = false;
//   }

//   closeResults(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = '';
//       this.removeAttribute('results');
//     }
//     const selected = this.querySelector('[aria-selected="true"]');
//     if (selected) selected.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', '');
//     this.removeAttribute('loading');
//     this.removeAttribute('open');
//     this.input.setAttribute('aria-expanded', false);
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute('style');
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);



// --- Recent searches storage helpers ---
const RECENT_SEARCHES_KEY = 'orient:recent-searches';
const RECENT_SEARCHES_LIMIT = 5;

function getRecentSearches() {
  try {
    const stored = JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY));
    return Array.isArray(stored) ? stored : [];
  } catch (e) {
    return [];
  }
}

function saveRecentSearch(term) {
  const trimmed = (term || '').trim();
  if (!trimmed) return;

  let searches = getRecentSearches().filter(
    (item) => item.toLowerCase() !== trimmed.toLowerCase()
  );
  searches.unshift(trimmed);
  searches = searches.slice(0, RECENT_SEARCHES_LIMIT);

  try {
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
  } catch (e) {
    // localStorage unavailable (private mode etc.) — fail silently
  }
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.searchFormInitialized) return;
    this.searchFormInitialized = true;

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.recentSearchesContainer = this.querySelector('[data-search-empty-state]');
    this.recentSearchesList = this.querySelector('[data-recent-searches-list]');
    this.popularSearchesContainer = this.querySelector('[data-popular-searches]');
    this.popularSearchesList = this.querySelector('[data-popular-searches-list]');
    this.quickCategoriesRoot = this.querySelector('[data-quick-categories]');
    this.detailsElement = this.closest('details');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      // Immediate (non-debounced) — purely toggles empty-state vs results visibility
      this.input.addEventListener('input', this.onInputImmediate.bind(this));
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
    }

    if (this.detailsElement) {
      this.detailsElement.addEventListener('toggle', this.onDetailsToggle.bind(this));
      this.detailsObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            this.onDetailsToggle();
          }
        }
      });
      this.detailsObserver.observe(this.detailsElement, { attributes: true });
    }

    if (this.recentSearchesList) {
      this.recentSearchesList.addEventListener('click', this.onRecentSearchClick.bind(this));
    }

    if (this.popularSearchesList) {
      this.popularSearchesList.addEventListener('click', this.onRecentSearchClick.bind(this));
    }

    if (this.quickCategoriesRoot) {
      this.quickCategoriesRoot.addEventListener('click', this.onQuickCategoriesClick.bind(this));
    }

    this.renderRecentSearches();
    this.refreshPopularProductsSlider();

    if (!this.popularProductsSliderInitialized) {
      document.addEventListener('DOMContentLoaded', () => this.refreshPopularProductsSlider());
      window.addEventListener('load', () => this.refreshPopularProductsSlider());
    }
  }

  moveCursorToEnd() {
    if (!this.input || !this.input.value) return;
    const len = this.input.value.length;
    if (typeof this.input.setSelectionRange === 'function') {
      try {
        this.input.setSelectionRange(len, len);
      } catch (e) {
        const val = this.input.value;
        this.input.value = '';
        this.input.value = val;
      }
    }
  }

  focusInput() {
    if (!this.input) return;
    this.input.focus();
    this.moveCursorToEnd();
    requestAnimationFrame(() => this.moveCursorToEnd());
  }

  onDetailsToggle() {
    if (!this.detailsElement.open) {
      this.hideRecentSearches();
      this.resetQuickCategories();
      if (typeof this.closeResults === 'function') this.closeResults(true);
      return;
    }

    this.resetQuickCategories();
    this.showRecentSearches();
    this.refreshPopularProductsSlider();
    setTimeout(() => this.refreshPopularProductsSlider(), 50);
    setTimeout(() => this.refreshPopularProductsSlider(), 200);

    // rAF avoids a focus/scroll race while the modal is still animating in
    requestAnimationFrame(() => {
      if (window.innerWidth >= 768) {
        this.focusInput();
      } else if (this.input) {
        this.input.blur();
      }
      this.onInputFocus();
      this.refreshPopularProductsSlider();
    });
  }

  onInputFocus() {
    this.moveCursorToEnd();
    requestAnimationFrame(() => this.moveCursorToEnd());
    if (!this.getQuery().length) {
      this.showRecentSearches();
    } else {
      this.hideRecentSearches();
    }
  }

  onInputImmediate() {
    if (this.getQuery().length) {
      this.hideRecentSearches();
    } else {
      this.showRecentSearches();
    }
  }

  onRecentSearchClick(event) {
    const item = event.target.closest('[data-recent-search-term]');
    if (!item) return;

    const term = item.getAttribute('data-recent-search-term');
    this.input.value = term;
    this.focusInput();
    this.hideRecentSearches();
    this.onChange(); // fire immediately, don't wait on the debounce
  }

  getQuery() {
    return this.input.value.trim();
  }

  showRecentSearches() {
    if (!this.recentSearchesContainer) return;
    this.renderRecentSearches();
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.classList.add('hidden');
    }
    this.removeAttribute('open');
    this.removeAttribute('results');

    this.refreshPopularProductsSlider();
    requestAnimationFrame(() => this.refreshPopularProductsSlider());
    setTimeout(() => this.refreshPopularProductsSlider(), 50);
    setTimeout(() => this.refreshPopularProductsSlider(), 200);
  }

  hideRecentSearches() {
    if (!this.recentSearchesContainer) return;
    this.recentSearchesContainer.classList.add('hidden');
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.classList.remove('hidden');
    }
  }

  // renderRecentSearches() {
  //   if (!this.recentSearchesContainer) return;

  //   // Always show the empty-state panel itself (Quick Categories / Popular
  //   // Collections should render even with no search history)
  //   this.recentSearchesContainer.classList.remove('hidden');

  //   const searches = getRecentSearches();
  //   const recentSearchesBlock = this.recentSearchesContainer.querySelector('.recent-searches');

  //   if (!searches.length) {
  //     if (recentSearchesBlock) recentSearchesBlock.classList.add('hidden');
  //     return;
  //   }

  //   if (recentSearchesBlock) recentSearchesBlock.classList.remove('hidden');

  //   this.recentSearchesList.innerHTML = searches
  //     .map((term) => {
  //       const safeTerm = term.replace(/"/g, '&quot;');
  //       return `<li><button type="button" class="recent-searches__item" data-recent-search-term="${safeTerm}"><svg xmlns="http://www.w3.org/2000/svg" fill="#9c9c9c" width="16px" height="16px" viewBox="0 0 24.00 24.00" stroke="#9c9c9c" stroke-width="0.00024000000000000003"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"></path></g></svg>  ${term}</button></li>`;
  //     })
  //     .join('');
  // }

  renderRecentSearches() {
    if (!this.recentSearchesContainer) return;

    this.recentSearchesContainer.classList.remove('hidden');

    const searches = getRecentSearches();
    const recentSearchesBlock = this.recentSearchesContainer.querySelector('.recent-searches');

    if (!searches.length) {
      if (recentSearchesBlock) recentSearchesBlock.classList.add('hidden');
      if (this.popularSearchesContainer) this.popularSearchesContainer.classList.remove('hidden');
      return;
    }

    if (recentSearchesBlock) recentSearchesBlock.classList.remove('hidden');
    if (this.popularSearchesContainer) this.popularSearchesContainer.classList.add('hidden');

    this.recentSearchesList.innerHTML = searches
      .map((term) => {
        const safeTerm = term.replace(/"/g, '&quot;');
        return `<li><button type="button" class="recent-searches__item" data-recent-search-term="${safeTerm}"><svg xmlns="http://www.w3.org/2000/svg" fill="#9c9c9c" width="16px" height="16px" viewBox="0 0 24.00 24.00" stroke="#9c9c9c" stroke-width="0.00024000000000000003"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"></path></g></svg>  ${term}</button></li>`;
      })
      .join('');
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
      this.showRecentSearches();
    }
  }

  onQuickCategoriesClick(event) {
    const trigger = event.target.closest('[data-quick-categories-trigger]');
    if (trigger) {
      event.preventDefault();
      const targetId = trigger.getAttribute('data-target');
      const currentPanel = trigger.closest('[data-quick-categories-panel]');
      const targetPanel = this.quickCategoriesRoot.querySelector(`[data-panel-id="${targetId}"]`);
      if (currentPanel && targetPanel) {
        currentPanel.classList.remove('search-quick-categories__panel--active');
        targetPanel.classList.add('search-quick-categories__panel--active');
        targetPanel.querySelector('[data-quick-categories-back]')?.focus();
      }
      return;
    }

    const backButton = event.target.closest('[data-quick-categories-back]');
    if (backButton) {
      event.preventDefault();
      const currentPanel = backButton.closest('[data-quick-categories-panel]');
      const parentId = currentPanel?.getAttribute('data-parent-id');
      const parentPanel = parentId
        ? this.quickCategoriesRoot.querySelector(`[data-panel-id="${parentId}"]`)
        : null;
      if (currentPanel && parentPanel) {
        currentPanel.classList.remove('search-quick-categories__panel--active');
        parentPanel.classList.add('search-quick-categories__panel--active');
        parentPanel.querySelector('[data-quick-categories-back], [data-quick-categories-trigger]')?.focus();
      }
    }
  }

  // NEW — always return to the root category list next time the search opens
  resetQuickCategories() {
    if (!this.quickCategoriesRoot) return;
    this.quickCategoriesRoot.querySelectorAll('[data-quick-categories-panel]').forEach((panel) => {
      panel.classList.toggle('search-quick-categories__panel--active', panel.dataset.level === '0');
    });
  }

  refreshPopularProductsSlider() {
    const $slider = window.jQuery && this.querySelector('[data-popular-products-slider]');
    if (!$slider || !window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.slick !== 'function') return;

    if (!this.popularProductsSliderInitialized || !window.jQuery($slider).hasClass('slick-initialized')) {
      this.initPopularProductsSlider();
    }
    if (window.jQuery($slider).hasClass('slick-initialized')) {
      window.jQuery($slider).slick('setPosition');
    }
  }

  initPopularProductsSlider() {
    const $slider = window.jQuery && this.querySelector('[data-popular-products-slider]');
    if (!$slider || !window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.slick !== 'function') return;

    if (this.popularProductsSliderInitialized && window.jQuery($slider).hasClass('slick-initialized')) return;

    this.popularProductsSliderInitialized = true;
    window.jQuery($slider).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      prevArrow: [`<button type="button" class="slick-prev" aria-label="`,
                  `">`,
                 `<span class="custom-arrow"><svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><defs><style>.a{fill:none;stroke:#fff;stroke-width:2px;}</style></defs><path class="a" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span>`,
                    `</button>`,].join(''),
      nextArrow: [
        `<button type="button" class="slick-next" aria-label="`,
        `">`,
        `<span class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><defs><style>.a{fill:none;stroke:#fff;stroke-width:2px;}</style></defs><path class="a" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span>`,
        `</button>`,
      ].join(''),
      responsive: [
        { breakpoint: 990, settings: { slidesToShow: 3, slidesToScroll: 1, arrows: true } },
        { breakpoint: 750, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: true } },
        { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: true } },
      ],
    });

    if ($slider.offsetWidth > 0) {
      window.jQuery($slider).slick('setPosition');
    }
  }
}

customElements.define('search-form', SearchForm);


class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.predictiveSearchInitialized) return;
    this.predictiveSearchInitialized = true;

    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');

    // Record a term as "recent" whenever a result is actually clicked
    this.predictiveSearchResults.addEventListener('click', (event) => {
      if (event.target.closest('a') && this.searchTerm) {
        saveRecentSearch(this.searchTerm);
      }
    });

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  onInputImmediate() {
    super.onInputImmediate();
    if (!this.getQuery().length) {
      if (this.abortController) {
        this.abortController.abort();
      }
      this.closeResults(true);
      this.showRecentSearches();
    } else {
      this.hideRecentSearches();
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      if (this.abortController) {
        this.abortController.abort();
      }
      this.close(true);
      this.showRecentSearches();
      return;
    }

    this.hideRecentSearches();
    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
    }
    if (this.getQuery().length) {
      saveRecentSearch(this.getQuery());
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      this.closeResults(true);
      this.showRecentSearches();
    }
  }

  onFocus() {
    this.moveCursorToEnd();
    requestAnimationFrame(() => this.moveCursorToEnd());
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) {
      this.showRecentSearches();
      return;
    }

    this.hideRecentSearches();

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      const activeEl = document.activeElement;
      if (this.detailsElement && this.detailsElement.contains(activeEl)) return;
      if (!this.contains(activeEl)) {
        this.close();
        if (!this.detailsElement || !this.detailsElement.open) {
          this.hideRecentSearches();
        }
      }
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    if (!previousTerm) return;
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      try {
        const escaped = previousTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const matches = currentButtonText.match(new RegExp(escaped, 'g'));
        if (matches && matches.length > 1) {
          return;
        }
        const newButtonText = currentButtonText.replace(new RegExp(escaped, 'g'), newTerm);
        searchForTextElement.innerText = newButtonText;
      } catch (e) {
        // fail gracefully if regex error occurs
      }
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      if (this.getQuery() !== searchTerm) return;
      this.renderSearchResults(this.cachedResults[queryKey]);
      const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);
      searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      return;
    }

    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        if (this.getQuery() !== searchTerm) {
          return;
        }

        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
        searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      })
      .catch((error) => {
        if (error?.name === 'AbortError' || error?.code === 20) {
          searchDeferred?.reject(error);
          return;
        }
        searchDeferred?.reject(error);
        this.close();
        throw error;
      });
  }

  getTotalResultCount() {
    return parseInt(this.predictiveSearchResults.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
  }

  dispatchSearchUpdateEvent(query) {
    const { SearchUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent) return null;

    const deferred = SearchUpdateEvent.createPromise();
    this.dispatchEvent(
      new SearchUpdateEvent({
        search: { query },
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    if (!this.getQuery().length) {
      this.close(true);
      this.showRecentSearches();
      return;
    }

    this.hideRecentSearches();
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.initLazyImages();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  initLazyImages() {
    const lazyImages = this.predictiveSearchResults.querySelectorAll('[defer-img-lazy]');
    lazyImages.forEach((img) => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('defer-img-lazy');
      }
    });
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);